function promoPopup() {
	const popupElement = document.querySelector('.cs-promo-popup');

	if (!popupElement) return;

	const closeButtonElement = popupElement.querySelector(
		'.cs-popup__close-button',
	);
	const linkElements = popupElement.querySelectorAll('.cs-popup__link');

	const STORAGE_KEY = 'promoPopupClosedAt';
	const DAY_MS = 24 * 60 * 60 * 1000;

	const closedAt = localStorage.getItem(STORAGE_KEY);

	if (closedAt && Date.now() - Number(closedAt) < DAY_MS) {
		return;
	}

	setTimeout(() => {
		popupElement.showModal();
	}, 5000);

	function closePopup() {
		localStorage.setItem(STORAGE_KEY, Date.now().toString());
		popupElement.close();
	}

	if (closeButtonElement) {
		closeButtonElement.addEventListener('click', closePopup);
	}

	linkElements.forEach(linkElement =>
		linkElement.addEventListener('click', closePopup),
	);

	popupElement.addEventListener('click', event => {
		const rect = popupElement.getBoundingClientRect();

		const isInside =
			event.clientX >= rect.left &&
			event.clientX <= rect.right &&
			event.clientY >= rect.top &&
			event.clientY <= rect.bottom;

		if (!isInside) {
			closePopup();
		}
	});
}

function main() {
	promoPopup();
}

document.addEventListener('DOMContentLoaded', main);

if (Shopify && Shopify.designMode) {
	document.addEventListener('shopify:section:load', main);
}
